const getters = {
    //步骤数
    stepNum:state=>{
        return state.companyStep.step;
    },
    //单位人员
    companyUsers : state => {
        return state.companyUserList;
    },
    globalAddressList : state => {
        return state.addressList;
    }
};

export default getters;


// WEBPACK FOOTER //
// ./src/store/getters.js